import type {
  InternalServicePermission,
  InternalServiceRoleHolder,
  InternalServiceWithPermissions
} from '@percent/admin-dashboard/api/actions/internalServices/internalServices.types'

export const allServicePermissions: Record<InternalServicePermission, boolean> = {
  can_read: true,
  can_edit: true,
  can_delete: true,
  can_view_roles: true,
  can_set_roles: true
}

export const buildInternalService = (
  overrides: Partial<InternalServiceWithPermissions> = {}
): InternalServiceWithPermissions => ({
  id: 'service_1',
  name: 'Scheduled processes',
  description: 'Runs the nightly jobs',
  ownerTeam: 'nexus',
  createdBy: 'account_1',
  createdAt: '2026-10-01T09:00:00Z',
  updatedAt: '2026-10-02T09:00:00Z',
  _permissions: allServicePermissions,
  ...overrides
})

export const mockInternalServices = [
  buildInternalService(),
  buildInternalService({ id: 'service_2', name: 'Payouts', ownerTeam: 'payments', description: null })
]

export const mockInternalServicesResponse = {
  object: 'service',
  data: mockInternalServices,
  totalResults: mockInternalServices.length,
  pageSize: 25,
  _links: { current: 'https://api.example.com/v1/admin/services' }
}

export const buildServiceRoleHolder = (
  overrides: Partial<InternalServiceRoleHolder> = {}
): InternalServiceRoleHolder => ({
  id: 'servicerole_1',
  serviceId: 'service_1',
  holderId: 'account_1',
  holderType: 'account',
  holderName: 'Ada Lovelace',
  role: 'owner',
  createdBy: 'account_1',
  createdAt: '2026-10-01T09:00:00Z',
  ...overrides
})

export const mockServiceRoleHolders = [
  buildServiceRoleHolder(),
  buildServiceRoleHolder({
    id: 'servicerole_2',
    holderId: 'group_1',
    holderType: 'group',
    holderName: 'Platform',
    role: 'reader'
  })
]

export const mockServiceRolesResponse = { object: 'service_role', data: mockServiceRoleHolders }
